//
// Copyright (c) 2023 Emplifi, Inc.
//

import { InputView, type LabeledFieldView, type Locale } from "ckeditor5";

export default class InputEmailView extends InputView {
  constructor(locale: Locale) {
    super(locale);
    this.extendTemplate({
      attributes: {
        class: ["ck-input-text", "ak-input-email"],
        type: "email",
      },
    });
  }
}

export function createLabeledInputEmail(
  labeledFieldView: LabeledFieldView,
  viewUid: string,
  statusUid: string,
): InputEmailView {
  const inputEmailView = new InputEmailView(labeledFieldView.locale!);
  inputEmailView.set({
    ariaDescribedById: statusUid,
    id: viewUid,
  });
  inputEmailView.bind("isReadOnly").to(labeledFieldView, "isEnabled", (enabled) => !enabled);
  inputEmailView.bind("hasError").to(labeledFieldView, "errorText", (errorText) => !!errorText);
  labeledFieldView.bind("isEmpty", "isFocused", "placeholder").to(inputEmailView);
  return inputEmailView;
}
